import { PostHog, useFeatureFlagVariantKey } from "posthog-js/react";

export const forceParameterFeatureFlags = (posthog: PostHog) => {
  const params = new URLSearchParams(window.location.search);
  const ffParam = params.get("ff");

  if (!ffParam) return;

  // Parse the feature flag overrides
  // Format: flag1:value1,flag2:value2
  const overrides: Record<string, string | boolean> = {};

  ffParam.split(",").forEach((pair) => {
    const [flag, value] = pair.split(":");
    if (flag && value !== undefined) {
      // Convert "true"/"false" strings to booleans
      if (value === "true") {
        overrides[flag.trim()] = true;
      } else if (value === "false") {
        overrides[flag.trim()] = false;
      } else {
        overrides[flag.trim()] = value.trim();
      }
    }
  });

  if (Object.keys(overrides).length > 0) {
    posthog.featureFlags.overrideFeatureFlags({ flags: overrides });
  }
}
// Feature flag hooks
export const useQuizInterstitials = () => useFeatureFlagVariantKey("quiz_interstitials") === "experiment";
